export default __webpack_public_path__ + "static/media/event_empty_state.7fd92ee7.svg";